"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _i18next = _interopRequireDefault(require("i18next"));
var _i18nextBrowserLanguagedetector = _interopRequireDefault(require("i18next-browser-languagedetector"));
var _i18nextHttpBackend = _interopRequireDefault(require("i18next-http-backend"));
var _reactI18next = require("react-i18next");
var _StaticBackend = _interopRequireDefault(require("./StaticBackend"));
var _MergeBackend = _interopRequireDefault(require("./MergeBackend"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class I18NextDelegate {
  async init(config) {
    const {
      use = [],
      initReact = true,
      options
    } = config;
    _i18next.default.use(_i18nextBrowserLanguagedetector.default);
    if (options?.resources == null) {
      _i18next.default.use(_MergeBackend.default);
    }
    use.forEach(u => {
      _i18next.default.use(u);
    });

    // Init the react provider
    if (initReact !== false) {
      _i18next.default.use(_reactI18next.initReactI18next);
    }
    await _i18next.default.init({
      ...options,
      fallbackLng: options?.fallbackLng || ['en-us', 'en'],
      returnObjects: true,
      backend: {
        backends: [_StaticBackend.default, _i18nextHttpBackend.default]
      }
    });
    _i18next.default.services.formatter.add('array', (val, lng, opts) => {
      if (val == null || !Array.isArray(val)) {
        return val;
      }
      let join = opts?.join || ', ';
      join = join.replaceAll("'", '');
      return val.join(join);
    });
    return _i18next.default;
  }
  i18n = () => {
    return _i18next.default;
  };
}
exports.default = I18NextDelegate;